enum CachePolicy {
  CACHE_FIRST = 'cache-first',
  CACHE_ONLY = 'cache-only',
  CACHE_AND_NETWORK = 'cache-and-network',
  NETWORK_ONLY = 'network-only',
  NO_CACHE = 'no-cache',
  STANDBY = 'standby',
}

export default CachePolicy;
